/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { InvoiceListSummaryVo } from './invoice-list-summary-vo.model';

export class InvoiceListMeta {
  totalSize: number | undefined = undefined;
  paymentStatuses: string[] | undefined = undefined;
  invoiceTypes: string[] | undefined = undefined;
  invoiceStatuses: string[] | undefined = undefined;
  currencyCodes: string[] | undefined = undefined;
  anafInvoiceStatuses: string[] | undefined = undefined;
  invoiceListSummaryVo: InvoiceListSummaryVo | undefined = undefined

  constructor() {
    this.totalSize = 0;
    this.paymentStatuses = [];
    this.invoiceTypes = []
    this.invoiceStatuses = [];
    this.currencyCodes = [];
    this.anafInvoiceStatuses = [];
    this.invoiceListSummaryVo = undefined;
  }
}
